export default __webpack_public_path__ + "web/react/components/send-to-app-banner/images/lyst-mobile-devices.2f5bb3f3ccb375b9007e87c578cb9c07.png";